import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomService } from 'app/components/dom/dom.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ExhibitorProfileService } from 'app/components/exhibitor-profile/exhibitor-profile.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import { CataloguePlansService } from 'app/components/catalogue-plans/catalogue-plans.service';
import { UtilsService } from 'app/components/utils/utils.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalExhibitorModifiedComponent } from 'app/components/modal-exhibitor-modified/modal-exhibitor-modified.component';
import {AlertService} from "../../components/alert/alert.service";


@Component({
  selector: 'app-exhibitor-backoffice-exhibitor-detail-admin-edit',
  templateUrl: './exhibitor-backoffice-exhibitor-detail-admin-edit.component.html',
  styleUrls: ['./exhibitor-backoffice-exhibitor-detail-admin-edit.component.css']
})
export class ExhibitorBackofficeExhibitorDetailAdminEditComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  catalogueId: string|null = '';
  catalogueName: string|null = '';
  exhibitorId: string|null = '';

  buttonLink: string = '';
  frontendLink: string = '';

  profile: object = {};

  exhibitorData: object = {
    exhibitor: {},
    exhibitorId: null
  };

  exhibitorStatuses: Array<any> = [];
  cataloguePlans: Array<any> = [];

  visibilityOptions:Array<any> = [
    { value: '1', label: 'COMMON.YES' },
    { value: '0', label: 'COMMON.NO' },
    { value: '-1', label: 'COMMON.NA' }
  ];

  constructor(private domService: DomService, private activatedRoute: ActivatedRoute, private exhibitorProfileService: ExhibitorProfileService,
  public catalogueService: CatalogueService, private exhitorsService: ExhitorsService, private cataloguePlansService: CataloguePlansService,
  public utilsService: UtilsService, private router: Router, private ngbModal: NgbModal, private alertService: AlertService) {
    this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('exhibitorId') || null;
    this.catalogueName = this.activatedRoute.snapshot.paramMap.get('event') || null;
    this.buttonLink = this.catalogueName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/exhibitor-detail-admin'
    this.frontendLink = this.catalogueService.getProperty('id') + '/' + this.catalogueName + '/exhibitor/' + this.exhibitorId + '/detail';
  }

  getProfile(getProfileIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhibitorProfileService.getProfile(getProfileIn)
      .subscribe((data: object) => {
        this.getProfileOk(data);
      },
        error => {
          this.getProfileError(error);
        });

  }

  getProfileOk(data) {

    this.loader.count--;
    this.profile = data;

  }

  getProfileError(error) {

    let alertData = {
      type: 'error',
      message: 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.ERRORS.GET_PROFILE_DATA'
    }

    this.loader.count--;
    this.alertService.addAlert(alertData);

  }

  getStatuses() {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getStatuses()
      .subscribe((data: object) => {
        this.getStatusesOk(data);
      },
        error => {
          this.getStatusesError(error);
        });

  }

  getStatusesOk(data) {
    this.loader.count--;
    this.exhibitorStatuses = data._embedded.exhibitorStatus;
  }

  getStatusesError(error) {

    let alertData = {
      type: 'error',
      message: 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.ERRORS.GET_STATUSES'
    }

    this.loader.count--;
    this.alertService.addAlert(alertData);

  }


  getByEventName(getByEventNameIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.cataloguePlansService.getByEventName(getByEventNameIn)
      .subscribe((data: object) => {
        this.getByEventNameOk(data);
      },
        error => {
          this.getByEventNameError(error);
        });

  }

  getByEventNameOk(data) {
    this.loader.count--;
    this.cataloguePlans = data._embedded.cataloguePlans;
  }

  getByEventNameError(error) {

    let alertData = {
      type: 'error',
      message: 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.ERRORS.GET_EVENT_DATA'
    }

    this.loader.count--;
    this.alertService.addAlert(alertData);

  }


  cancel() {
    this.router.navigate([this.buttonLink]);
  }

  saveBtn() {

    let getLoginDataIn = {
      exhibitorId: this.exhibitorId,
      catalogueUserName: this.profile['catalogueUserName']
    }

    this.getLoginData(getLoginDataIn);

  }

  saveProfile(saveProfileIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhibitorProfileService.saveProfile(saveProfileIn)
      .subscribe((data: object) => {
        this.saveProfileOk(data);
      },
        error => {
          this.saveProfileError(error);
        });

  }

  saveProfileOk(data) {

    this.loader.count--;

    /** Set data to model */

  }

  saveProfileError(error) {

    let alertData = {
      type: 'error',
      message: 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.ERRORS.SAVE_PROFILE'
    }

    this.loader.count--;
    this.alertService.addAlert(alertData);

  }

  getLoginData(getLoginDataIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhibitorProfileService.getLoginData(getLoginDataIn)
      .subscribe((data: object) => {
        this.getLoginDataOk(data);
      },
        error => {
          this.getLoginDataError(error);
        });

  }

  getLoginDataOk(data) {

    this.loader.count--;

    if (data.hasChanged && data.associatedExhibitors > 1) {
      this.openModalExhibitorModified(data.oldUserName, data.associatedExhibitors);
    } else {

      let saveProfileIn = {
        eventName: this.catalogueName,
        exhibitorId: parseInt(this.exhibitorId || ''),
        cataloguePlanId: this.profile['planId'].toString(),
        statusId: this.profile['statusId'].toString(),
        visibility: this.profile['businessVisibility'].toString(),
        userName: this.profile['catalogueUserName'],
        catalogueUserId: this.profile['catalogueUserId'],
        published: this.profile['published'],
        copyAllowed: this.profile['copyAllowed'],
        businessNoveltiesLimit: this.profile['businessNoveltiesLimit'],
        catalogueUsers: this.profile['catalogueUsers'],
        changeAllUserNames: false
      }

      this.saveProfile(saveProfileIn);

    }

  }

  getLoginDataError(error) {

    let alertData = {
      type: 'error',
      message: 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.ERRORS.GET_LOGIN_DATA'
    }

    this.loader.count--;
    this.alertService.addAlert(alertData);

  }


  openModalExhibitorModified(oldUsername, associatedExhibitors) {

    let modalRef = this.ngbModal.open(ModalExhibitorModifiedComponent);
    modalRef.componentInstance.oldEmail = oldUsername;
    modalRef.componentInstance.affectedExhibitors = associatedExhibitors;

    modalRef.result.then( (option) => {

      if (option === 'all' || option === 'this') {

        let saveProfileIn = {
          eventName: this.catalogueName,
          exhibitorId: parseInt(this.exhibitorId || ''),
          cataloguePlanId: this.profile['planId'].toString(),
          statusId: this.profile['statusId'].toString(),
          visibility: this.profile['businessVisibility'].toString(),
          userName: this.profile['catalogueUserName'],
          published: this.profile['published'],
          copyAllowed: this.profile['copyAllowed'],
          businessNoveltiesLimit: this.profile['businessNoveltiesLimit'],
          changeAllUserNames: option === 'all' ? true : false
        }

        this.saveProfile(saveProfileIn);

      }

    });

  }

  goTo(url) {
    this.router.navigate([url]);
  }

  ngOnInit() {

    this.domService.addClassToBody('bg-gray');
    this.exhibitorData['exhibitorId'] = this.exhibitorId;

    this.getStatuses();

    let getProfileIn = {
      catalogueId: this.catalogueService.getProperty('id'),
      exhibitorId: this.exhibitorId
    }

    this.getProfile(getProfileIn);

    let getByEventNameIn = {
      eventName: this.catalogueName
    }

    this.getByEventName(getByEventNameIn);

  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}
